var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      [
        _c("busqueda", {
          attrs: { month: true, routeData: _vm.routeData, fecha: _vm.fecha },
          on: { search: _vm.search },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "row mt-3" }, [
      _c("div", { staticClass: "col-lg-12 col-md-12 col-12" }, [
        _c("div", { staticClass: "ibox " }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "ibox-content" }, [
            _c(
              "table",
              {
                staticClass:
                  "table table-striped table-bordered w-100 tabla-default",
              },
              [
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.data, function (item, index) {
                    return _c("tr", { key: index }, [
                      _c("td", [_vm._v(_vm._s(item.nombre))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(item.descripcion))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(item.cantidad))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(item.tipo))]),
                    ])
                  }),
                  0
                ),
              ]
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ibox-title" }, [
      _c("div", { staticClass: "ibox-tools" }, [
        _c("a", { staticClass: "collapse-link" }, [
          _c("i", { staticClass: "fa fa-chevron-up" }),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [
          _c("i", { staticClass: "fal fa-address-card" }),
          _vm._v(" Nombre"),
        ]),
        _vm._v(" "),
        _c("th", [
          _c("i", { staticClass: "fal fa-address-card" }),
          _vm._v(" Descripcion"),
        ]),
        _vm._v(" "),
        _c("th", [
          _c("i", { staticClass: "fal fa-address-card" }),
          _vm._v(" Cantidad"),
        ]),
        _vm._v(" "),
        _c("th", [
          _c("i", { staticClass: "fal fa-address-card" }),
          _vm._v(" Tipo"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }